import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22global-error.tsx%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22./fonts/geist-sans/Geist-Medium.woff2%22,%22weight%22:%22500%22,%22style%22:%22normal%22},{%22path%22:%22./fonts/geist-sans/Geist-SemiBold.woff2%22,%22weight%22:%22600%22,%22style%22:%22normal%22}],%22variable%22:%22--font-geist-sans%22,%22fallback%22:[%22ui-sans-serif%22,%22system-ui%22,%22-apple-system%22,%22BlinkMacSystemFont%22]}],%22variableName%22:%22geistSans%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'geistSans', 'geistSans Fallback', ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
